/**
 * Párrafo item
 * @param {*} editor
 */
function grey(editor) {
  const cm = editor.codemirror;
  const selectedText = cm.getSelection();
  const text = selectedText;

  const output = `/g/${text}/g/`;
  cm.replaceSelection(output);
}

export default function () {
  const option = {
    name: 'Tenue',
    action: grey,
    className: 'zmdi zmdi-format-color-reset',
    title: 'Tenue',
  };

  return option;
}
